module.exports = __webpack_public_path__ + "img/top_inside_full.48315add.svg";